import { render, staticRenderFns } from "./IndustryEventShapePC.vue?vue&type=template&id=515baa80&scoped=true&"
import script from "./IndustryEventShapePC.vue?vue&type=script&lang=js&"
export * from "./IndustryEventShapePC.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./IndustryEventShapePC.vue?vue&type=style&index=0&id=515baa80&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "515baa80",
  null
  ,true
)

export default component.exports